
export class Alert {
    camera: CameraAlert;
    externalId: string;
    date: string;
    location: string | LatlngConvert;
    status: string;
    state: string;
    medias: Media[];
    id: string;
    type: string;
    modifiedBy?: string;
    modifiedOn?: string;
}

export class Media {
    externalId: string;
    type: string;
    uploadSession: UploadSession;
    id: string;
}

export class UploadSession {
    fileSize: number;
    fileExtension: string;
    checkSum: string;
    chunkSize: number;
    uploadedChunks: number;
    totalChunks: number;
    startedOn: string;
    completedOn?: string;
    id: string;
}

export class CameraAlert {
    name: string;
    externalId: string;
    id: string;
}

export class LatlngConvert {
    lng: number;
    lat: number;

    constructor(lat: number, lng: number) {
        this.lng = lng;
        this.lat = lat;

    }

}

export class UpdateState {
    state: string;

    constructor(state: string) {
        this.state = state;
    }

}
export class UpdateAlert {
    status: string;

    constructor(status: string) {

        this.status = status;
    }

}
